var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgMoneyGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.177 0.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-0.177 -0.177)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.757,19.86H19.206a1.552,1.552,0,0,0-1.551-1.551v0A4.654,4.654,0,0,1,13,13.654h0A4.654,4.654,0,0,1,17.654,9h3.1a1.551,1.551,0,0,1,0,3.1h-3.1A1.552,1.552,0,0,0,16.1,13.654h0a1.552,1.552,0,0,0,1.551,1.551v0a4.654,4.654,0,0,1,4.654,4.654h0a4.654,4.654,0,0,1-4.654,4.654h-3.1a1.551,1.551,0,0,1,0-3.1h3.1a1.552,1.552,0,0,0,1.551-1.551Zm0,0h0Z",
    transform: "translate(7.168 15.823)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15,8.552v3.1a1.551,1.551,0,1,0,3.1,0v-3.1a1.551,1.551,0,1,0-3.1,0Zm3.1,18.617v-3.1a1.551,1.551,0,1,0-3.1,0v3.1a1.551,1.551,0,1,0,3.1,0Z",
    transform: "translate(8.271 14.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.954,4.556A17.066,17.066,0,1,0,42.02,21.621,17.074,17.074,0,0,0,24.954,4.556Zm0,3.1A13.963,13.963,0,1,1,10.992,21.621,13.968,13.968,0,0,1,24.954,7.658Z",
    transform: "translate(-0.132 10.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15,74.053v10.86a1.551,1.551,0,1,0,3.1,0V74.053a1.551,1.551,0,1,0-3.1,0Z",
    transform: "translate(8.271 -67.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.739,3.239c-2.18,2.18-2.292,5.387-.549,7.131S21.141,12,23.321,9.822s2.292-5.388.549-7.131S18.919,1.06,16.739,3.239Zm2.194,2.194c.852-.852,2.06-1.231,2.743-.549s.3,1.89-.549,2.743-2.06,1.231-2.743.549S18.081,6.286,18.933,5.434Z",
    transform: "translate(8.262 0.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.821,1.767c-2.18-2.18-5.387-2.292-7.131-.549s-1.631,4.951.549,7.131,5.387,2.292,7.131.549S21,3.947,18.821,1.767ZM16.627,3.961c.852.852,1.231,2.06.549,2.743s-1.89.3-2.743-.549-1.231-2.06-.549-2.743S15.775,3.108,16.627,3.961Z",
    transform: "translate(5.781 0.006)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGrowth);
export default __webpack_public_path__ + "static/media/money-growth.7002b306.svg";
export { ForwardRef as ReactComponent };